import React from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "../components/ui/dialog";
import { Button } from "../components/ui/button";
import { Lock, UserPlus, ArrowRight } from "lucide-react";

/**
 * v2.63 — Sign-up first gate. Per onboarding spec, new users should NOT see a
 * Login + Signup choice (creates decision fatigue). The big CTA is "Sign up";
 * existing users get a small inline "Already have an account? Sign in" link
 * underneath.
 */
export default function AuthGate({ open, onClose, action = "continue", returnTo = null }) {
  const nav = useNavigate();
  const loc = useLocation();
  const dest = returnTo || loc.pathname + loc.search;

  const go = (path) => {
    onClose?.();
    nav(`${path}?next=${encodeURIComponent(dest)}`);
  };

  return (
    <Dialog open={open} onOpenChange={(v) => !v && onClose?.()}>
      <DialogContent className="max-w-sm rounded-sm" data-testid="auth-gate-dialog">
        <DialogHeader>
          <div className="mx-auto w-12 h-12 rounded-full bg-[#EEF4FF] border border-[#C7D9FF] flex items-center justify-center mb-2">
            <Lock size={20} className="text-[#0055FF]" />
          </div>
          <DialogTitle className="font-heading tracking-tight text-2xl text-center">
            Free account banaye — full details unlock karein
          </DialogTitle>
          <DialogDescription className="text-[13px] text-[#52525B] text-center">
            {action === "enquiry"
              ? "Enquiry bhejne ke liye account zaroori hai. Aapki details safe rahegi — sirf House Entry team contact karegi."
              : action === "details"
              ? "Property ki full details, ROI aur metro info dekhne ke liye free account banayein."
              : "Aage badhne ke liye free account banayein."}
          </DialogDescription>
        </DialogHeader>
        <div className="flex flex-col gap-3 mt-4">
          <Button
            className="btn-brand rounded-sm w-full h-11 text-[14px] font-bold"
            onClick={() => go("/register")}
            data-testid="auth-gate-register-btn"
          >
            <UserPlus size={14} className="mr-1.5" /> Sign up — it's free
            <ArrowRight size={14} className="ml-1.5" />
          </Button>
          <button
            type="button"
            onClick={() => go("/login")}
            className="text-center text-[12.5px] text-[#52525B] hover:text-[#0055FF] transition-colors w-full"
            data-testid="auth-gate-login-link"
          >
            Already have an account? <span className="text-[#0055FF] font-semibold">Sign in →</span>
          </button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
